import { render } from "./Quiz.vue?vue&type=template&id=93a58802&scoped=true"
import script from "./Quiz.vue?vue&type=script&lang=js"
export * from "./Quiz.vue?vue&type=script&lang=js"

import "./Quiz.vue?vue&type=style&index=0&id=93a58802&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\lpdadsm-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93a58802"]])

export default __exports__